import { render, staticRenderFns } from "./MailLogList.vue?vue&type=template&id=96e885f2&scoped=true&"
import script from "./MailLogList.vue?vue&type=script&lang=js&"
export * from "./MailLogList.vue?vue&type=script&lang=js&"
import style0 from "./MailLogList.vue?vue&type=style&index=0&id=96e885f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e885f2",
  null
  
)

export default component.exports